import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

export class TreeItemNode {
  children: TreeItemNode[];
  item: string;
  name: string;
  id: string;
  selected: boolean;
  parentId: string;
}

export class TreeItemFlatNode {
  item: string;
  level: number;
  expandable: boolean;
  name: string;
  id: string;
  selected: boolean;
  parentId: string;
}


@Component({
  selector: 'phdsoft-region-select',
  templateUrl: './region-select.component.html',
  styleUrls: ['./region-select.component.scss'],
})
export class RegionSelectComponent implements OnInit {

  @Input() Regions: any[]
  @Output() SelectRegion = new EventEmitter<{ regionId: string; }>()
  @Output() SelectSection = new EventEmitter<{ regionId: string; sectionId: string }>()
  // @Output() CheckRegion = new EventEmitter<{ regionId: string; }>()
  // @Output() CheckSection = new EventEmitter<{ regionId: string, sectionId: string }>()
  // @Output() SelectAll = new EventEmitter<{ isChecking: boolean }>()


  flatNodeMap = new Map<TreeItemFlatNode, TreeItemNode>();
  nestedNodeMap = new Map<TreeItemNode, TreeItemFlatNode>();
  treeControl: FlatTreeControl<TreeItemFlatNode>;
  treeFlattener: MatTreeFlattener<TreeItemNode, TreeItemFlatNode>;
  dataSource: MatTreeFlatDataSource<TreeItemNode, TreeItemFlatNode>;

  constructor() {

    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,
      this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TreeItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    // database.dataChange.subscribe(data => {

    //   this.dataSource.data = data;
    // });

    //this.dataSource = this.Regions


  }

  getLevel = (node: TreeItemFlatNode) => node.level;
  isExpandable = (node: TreeItemFlatNode) => node.expandable;
  getChildren = (node: TreeItemNode): TreeItemNode[] => node.children;
  transformer = (node: TreeItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item
      ? existingNode
      : new TreeItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.expandable = node.children && node.children.length > 0 || level == 0;
    expandable: !!node.children && node.children.length > 0,
      flatNode.name = node.name,
      flatNode.id = node.id,
      flatNode.selected = node.selected,
      flatNode.parentId = node.parentId,
      this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }
  hasChild = (_: number, node: any) => node.expandable


  ngOnInit(): void {


    this.dataSource.data = this.Regions;

    // this.Regions.map((x => ({
    //   name: x.RegionName,
    //   id: x.RegionId,
    //   selected: Boolean(x.RegionChecked),
    //   item: '',
    //   parentId: '',
    //   children: x.Sections.map(y => ({ name: y.SectionName, parentId: x.RegionId, selected: y.SectionChecked, id: y.SectionId }))

    // })));

  }

  onSelectRegion($event, node) {

    // var target = $event.target;
    // if (target.className.includes('mat-checkbox')) {
    //   return;
    // }
    this.SelectRegion.emit({ regionId: node.id })

  }

  onSelectSection($event, node) {

    // var target = $event.target;
    // if (target.className.includes('mat-checkbox')) {
    //   return;
    // }

    this.SelectSection.emit({ regionId: node.parentId, sectionId: node.id })

  }

  isRegionChecked(node) {

    var region = this.Regions.find((x) => x.id == node.id);

    var isAllSectionsSelected = region?.children?.every(x => x.selected);

    return Boolean(isAllSectionsSelected)

  }

  isSectionChecked(node) {


    return Boolean(
      this.Regions.find((x) => x.id == node.parentId)?.children?.find((x) => x.id == node.id)
        ?.selected,
    )
  }


  isRegionParcialVisible(node) {

    var sections = this.Regions.find((x) => x.id == node.id)?.children;

    var sectionsVisible = sections?.filter(t => t.selected);

    return Boolean(sectionsVisible?.length > 0 && sectionsVisible?.length !== sections?.length)

  }



}
